(function (angular) {
    'use strict';

    var FoundationRestUrls = (function () {
        function FoundationRestUrls() {
            this.content = "{{urlBase}}/apispaces/{{apiSpaceId}}/content";
            this.conversations = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats";
            this.conversation = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}";
            this.participants = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}/participants";
            this.typing = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}/typing";
            this.push = "{{urlBase}}/apispaces/{{apiSpaceId}}/sessions/{{sessionId}}/push";
            this.facebook = "{{urlBase}}/apispaces/{{apiSpaceId}}/channels/facebook/state";
            this.events = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}/events";
            this.messages = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}/messages";
            this.statusUpdates = "{{urlBase}}/apispaces/{{apiSpaceId}}/chats/{{conversationId}}/messages/statusupdates";
            this.profiles = "{{urlBase}}/apispaces/{{apiSpaceId}}/profiles";
            this.profile = "{{urlBase}}/apispaces/{{apiSpaceId}}/profiles/{{profileId}}";
            this.sessions = "{{urlBase}}/apispaces/{{apiSpaceId}}/sessions";
            this.sessionStart = "{{urlBase}}/apispaces/{{apiSpaceId}}/sessions/start";
            this.session = "{{urlBase}}/apispaces/{{apiSpaceId}}/sessions/{{sessionId}}";
        }
        return FoundationRestUrls;
    }());

    angular.module('shared')
        .service('FoundationRestUrls', FoundationRestUrls);

})(window.angular);
